import { useState } from "react";
import { Package } from "lucide-react";
import LenderPackageDialog from "./pfs/LenderPackageDialog";

/**
 * Drop-in trigger for the LenderPackageDialog. Used by Reports, Properties,
 * and Dashboard Overview so free landlords can grab a rent-roll-only package
 * without going through the (Pro-gated) PFS page.
 *
 * Pro users see the full dialog (PFS / rent roll / binder / comps + email +
 * share-link modes). Free users see the same dialog with Pro docs locked
 * off and Email/Share-link toggles hidden — server enforces the same.
 */
export default function LenderPackageButton({
  variant = "outline",
  size = "default",
  label = "Lender package",
  testid = "lender-package-btn",
  className = "",
}) {
  const [open, setOpen] = useState(false);

  const baseStyles = size === "sm"
    ? "text-xs px-3 py-1.5"
    : "text-sm px-4 py-2";

  const variantStyles = variant === "primary"
    ? "bg-emerald-600 hover:bg-emerald-700 text-white font-semibold"
    : variant === "ghost"
      ? "text-slate-600 hover:text-slate-900 hover:bg-slate-100"
      : "border border-slate-300 hover:border-slate-900 text-slate-700 hover:text-slate-900 font-medium";

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className={`inline-flex items-center gap-2 rounded-sm transition-colors ${baseStyles} ${variantStyles} ${className}`}
        data-testid={testid}
        title="Bundle PFS + rent roll + binder + comps for your lender"
      >
        <Package className={size === "sm" ? "w-3.5 h-3.5" : "w-4 h-4"} />
        {label}
      </button>
      <LenderPackageDialog open={open} onOpenChange={setOpen} />
    </>
  );
}
